import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Chart from "chart.js/auto";
import {
  faTags,
  faFire,
  faBoxOpen,
  faClock,
  faStore,
  faUsers,
  faGamepad,
  faCrown,
  faWallet,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

const tabs = [
  { key: "deals", label: "Hot Deals", icon: faFire },
  { key: "categories", label: "Offer Types", icon: faTags },
  { key: "groups", label: "Group Buy", icon: faUsers },
  { key: "sellers", label: "Sellers", icon: faStore },
  { key: "gamify", label: "Rewards", icon: faGamepad },
  { key: "magazine", label: "ShopperHub", icon: faCrown },
  { key: "wallet", label: "Wallet", icon: faWallet },
  { key: "insights", label: "Trends", icon: faChartLine },
];

const dummyDeals = [
  { id: 1, title: "Buy 1 Get 1 Free – Men T-Shirts", price: "₹499", offer: "BOGO", seller: "Factory Outlet – Tirupur", stock: "Limited" },
  { id: 2, title: "Kitchen Storage Combo Set", price: "₹199", offer: "Stock Clearance", seller: "Home Essentials – Delhi", stock: "High" },
  { id: 3, title: "Ladies Footwear (Seconds)", price: "₹299", offer: "Factory Seconds", seller: "Jaipur Boutique", stock: "Medium" },
  { id: 4, title: "Winter Jackets Mega Clearance", price: "₹999", offer: "70% Off", seller: "Himachal Woolens", stock: "Limited" },
  { id: 5, title: "Electronics Accessories Bundle", price: "₹399", offer: "Combo Deal", seller: "Gadget Hub – Mumbai", stock: "High" },
  { id: 6, title: "Organic Dry Fruits Pack", price: "₹599", offer: "End of Season", seller: "Farm Fresh – Punjab", stock: "Medium" },
  { id: 7, title: "Bedding Combo (Sheets + Pillow)", price: "₹799", offer: "BOGO", seller: "Textile World – Surat", stock: "High" },
  { id: 8, title: "Kids Toys Clearance Lot", price: "₹149", offer: "Stock Clearance", seller: "Toy Warehouse – Chennai", stock: "Limited" },
];

const offerTypes = [
  { name: "BOGO", count: 78 },
  { name: "₹99 Deals", count: 45 },
  { name: "₹199 Deals", count: 62 },
  { name: "₹299 Deals", count: 39 },
  { name: "End of Season Sale", count: 91 },
  { name: "Factory Direct", count: 54 },
  { name: "Seconds & Surplus", count: 67 },
  { name: "End of Day Clearance", count: 23 },
  { name: "Stock Clearance", count: 88 },
];

const dummyGroupBuys = [
  { id: 1, title: "10kg Premium Basmati Rice", current: 82, target: 100, price: "₹499", savings: "Save ₹150 each" },
  { id: 2, title: "Pack of 20 LED Bulbs (9W)", current: 41, target: 60, price: "₹799", savings: "Save ₹400 each" },
  { id: 3, title: "Winter Blanket Set (4 pcs)", current: 23, target: 50, price: "₹1,299", savings: "Save ₹700 each" },
  { id: 4, title: "Mobile Accessories Combo", current: 95, target: 100, price: "₹299", savings: "Save ₹200 each" },
  { id: 5, title: "Kitchen Cookware Set", current: 12, target: 30, price: "₹1,999", savings: "Save ₹1,000 each" },
];

const dummySellers = [
  { id: 1, name: "Tirupur Textile Factory", location: "Tirupur, TN", type: "Verified Manufacturer", rating: "4.9 (245)", deals: 52 },
  { id: 2, name: "Delhi Wholesale Hub", location: "Delhi", type: "Authorized Distributor", rating: "4.7 (189)", deals: 38 },
  { id: 3, name: "Jaipur Fashion Boutique", location: "Jaipur, RJ", type: "Retailer / Boutique", rating: "4.8 (156)", deals: 29 },
  { id: 4, name: "Clearance King Mumbai", location: "Mumbai", type: "Clearance & Seconds", rating: "4.5 (312)", deals: 71 },
  { id: 5, name: "Punjab Agro Direct", location: "Ludhiana, PB", type: "Verified Manufacturer", rating: "4.9 (98)", deals: 41 },
];

const dummyTransactions = [
  { date: "Jan 01, 2026", desc: "Cashback – Deal #456", amount: "+₹120" },
  { date: "Dec 31, 2025", desc: "Referral Bonus", amount: "+₹50" },
  { date: "Dec 28, 2025", desc: "Bank Withdrawal", amount: "-₹800" },
  { date: "Dec 25, 2025", desc: "Magazine Subscription", amount: "-₹29" },
  { date: "Dec 20, 2025", desc: "Group Buy Cashback", amount: "+₹85" },
];

export default function OfferHubHome() {
  const [activeTab, setActiveTab] = useState("deals");
  const [searchDeals, setSearchDeals] = useState("");
  const [searchGroups, setSearchGroups] = useState("");
  const [searchSellers, setSearchSellers] = useState("");

  const lineChartRef = useRef(null);
  const barChartRef = useRef(null);

  useEffect(() => {
    let lineChart = null;
    let barChart = null;

    if (activeTab === "insights") {
      if (lineChartRef.current) {
        lineChart = new Chart(lineChartRef.current, {
          type: "line",
          data: {
            labels: ["Dec 27", "Dec 28", "Dec 29", "Dec 30", "Dec 31", "Jan 01", "Jan 02"],
            datasets: [
              {
                label: "Daily Deal Views",
                data: [1200, 1500, 1800, 2200, 1900, 2500, 3000],
                borderColor: "#60a5fa",
                backgroundColor: "rgba(96, 165, 250, 0.2)",
                tension: 0.3,
                fill: true,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: "top" } },
            scales: { y: { beginAtZero: true } },
          },
        });
      }

      if (barChartRef.current) {
        barChart = new Chart(barChartRef.current, {
          type: "bar",
          data: {
            labels: ["BOGO", "Clearance", "₹199 Deals", "Seconds", "Group Buy"],
            datasets: [
              {
                label: "Views (Thousands)",
                data: [4.5, 3.8, 3.2, 2.8, 4.1],
                backgroundColor: "#60a5fa",
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: "top" } },
            scales: { y: { beginAtZero: true } },
          },
        });
      }
    }

    return () => {
      if (lineChart) lineChart.destroy();
      if (barChart) barChart.destroy();
    };
  }, [activeTab]);

  return (
    <section className="min-h-screen bg-black text-blue-400 px-3 py-4">
      {/* Header */}
      <header className="mb-4 text-center">
        <h1 className="text-xl font-bold text-blue-500">
          🛍️ OfferHub Marketplace
        </h1>
        <p className="text-xs text-gray-400">
          Deals • Clearance • Group Buying • Rewards
        </p>
      </header>

      {/* Tabs Grid */}
      <div className="grid grid-cols-4 sm:grid-cols-8 gap-2 mb-5">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`text-xs w-24 lg:text-sm lg:w-42 h-20 rounded-md flex flex-col items-center justify-center font-medium border
              ${
                activeTab === tab.key
                  ? "bg-blue-600 text-black border-blue-500"
                  : "bg-gray-900 text-blue-400 border-gray-700"
              }`}
          >
            <FontAwesomeIcon icon={tab.icon} className="text-lg mb-1" />
            <span className="text-center leading-tight">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="space-y-4">
        {/* Hot Deals */}
        {activeTab === "deals" && (
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Search deals by title, seller or offer..."
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-sm placeholder-gray-500"
              value={searchDeals}
              onChange={(e) => setSearchDeals(e.target.value)}
            />
            {dummyDeals
              .filter(
                (deal) =>
                  deal.title.toLowerCase().includes(searchDeals.toLowerCase()) ||
                  deal.seller.toLowerCase().includes(searchDeals.toLowerCase()) ||
                  deal.offer.toLowerCase().includes(searchDeals.toLowerCase())
              )
              .map((deal) => (
                <div
                  key={deal.id}
                  className="bg-gray-900 rounded-xl p-4 border border-gray-800"
                >
                  <h3 className="text-sm font-semibold text-blue-300">
                    {deal.title}
                  </h3>
                  <div className="text-xs text-gray-400 mt-1">
                    Seller: {deal.seller}
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    Stock: {deal.stock}
                  </div>
                  <div className="flex justify-between items-center mt-3">
                    <span className="text-lg font-bold text-blue-500">
                      {deal.price}
                    </span>
                    <span className="text-xs px-3 py-1 bg-blue-800 text-black rounded-full">
                      {deal.offer}
                    </span>
                  </div>
                  <button className="mt-4 text-xs w-24 lg:text-sm lg:w-64  bg-blue-600 text-black py-2.5 rounded-md font-semibold">
                    Buy Now
                  </button>
                </div>
              ))}
          </div>
        )}

        {/* Offer Types */}
        {activeTab === "categories" && (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {offerTypes.map((cat) => (
              <div
                key={cat.name}
                className="bg-gray-900 border border-gray-800 rounded-xl p-5 text-center"
              >
                <div className="text-sm font-medium text-blue-300">
                  {cat.name}
                </div>
                <div className="text-xs text-gray-400 mt-2">
                  {cat.count} active deals
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Group Buy */}
        {activeTab === "groups" && (
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Search group buys..."
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-sm placeholder-gray-500"
              value={searchGroups}
              onChange={(e) => setSearchGroups(e.target.value)}
            />
            {dummyGroupBuys
              .filter((g) =>
                g.title.toLowerCase().includes(searchGroups.toLowerCase())
              )
              .map((g) => (
                <div
                  key={g.id}
                  className="bg-gray-900 rounded-xl p-4 border border-gray-800"
                >
                  <h3 className="text-sm font-semibold text-blue-300">
                    {g.title}
                  </h3>
                  <div className="text-xs text-gray-400 mt-2">
                    {g.current}/{g.target} members joined
                  </div>
                  <div className="w-full bg-gray-700 rounded-full h-3 mt-2">
                    <div
                      className="bg-blue-600 h-3 rounded-full transition-all"
                      style={{ width: `${(g.current / g.target) * 100}%` }}
                    />
                  </div>
                  <div className="flex justify-between items-end mt-4">
                    <div>
                      <span className="text-lg font-bold text-blue-500">
                        {g.price} each
                      </span>
                      <p className="text-xs text-green-400">{g.savings}</p>
                    </div>
                    <button className="bg-blue-600 text-black px-5 py-2 rounded-lg text-xs w-24 lg:text-sm lg:w-42 font-semibold">
                      Join
                    </button>
                  </div>
                </div>
              ))}
            <button className="text-xs w-24 lg:text-sm lg:w-42 bg-blue-600 text-black py-3 rounded-lg font-semibold">
              Start New Group Buy
            </button>
          </div>
        )}

        {/* Sellers */}
        {activeTab === "sellers" && (
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Search sellers by name or location..."
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-sm placeholder-gray-500"
              value={searchSellers}
              onChange={(e) => setSearchSellers(e.target.value)}
            />
            {dummySellers
              .filter(
                (s) =>
                  s.name.toLowerCase().includes(searchSellers.toLowerCase()) ||
                  s.location.toLowerCase().includes(searchSellers.toLowerCase()) ||
                  s.type.toLowerCase().includes(searchSellers.toLowerCase())
              )
              .map((s) => (
                <div
                  key={s.id}
                  className="bg-gray-900 rounded-xl p-4 border border-gray-800"
                >
                  <h3 className="text-sm font-semibold text-blue-300">
                    {s.name}
                  </h3>
                  <p className="text-xs text-gray-400 mt-1">
                    {s.location} • {s.type}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">{s.rating}</p>
                  <p className="text-xs text-gray-400">
                    {s.deals} active deals
                  </p>
                  <button className="mt-4 text-xs w-40 lg:text-sm lg:w-64 bg-blue-600 text-black py-2.5 rounded-md font-semibold">
                    View Deals
                  </button>
                </div>
              ))}
          </div>
        )}

        {/* Rewards */}
        {activeTab === "gamify" && (
          <div className="space-y-6">
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-800 text-center">
              <h3 className="text-lg font-bold">Your Reward Status</h3>
              <p className="text-3xl font-bold text-blue-500 mt-3">
                1,850 Coins
              </p>
              <p className="text-sm mt-3">
                Level: <span className="text-yellow-400 font-semibold">Gold</span>
              </p>
              <div className="mt-4">
                <div className="flex justify-between text-xs text-gray-400">
                  <span>1,500</span>
                  <span>2,500 (Platinum)</span>
                </div>
                <div className="w-full bg-gray-700 rounded-full h-4 mt-1">
                  <div
                    className="bg-yellow-500 h-4 rounded-full"
                    style={{ width: "70%" }}
                  />
                </div>
              </div>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <h4 className="font-semibold mb-3">Earn Coins By</h4>
              <ul className="text-sm text-gray-400 space-y-2">
                <li>• Buying deals (5–10% cashback)</li>
                <li>• Referring friends (100 coins each)</li>
                <li>• Writing reviews</li>
                <li>• Daily login & streaks</li>
              </ul>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className="bg-gray-800 rounded-xl p-4 text-center text-2xl">
                🏆
                <p className="text-xs mt-2">Deal Master</p>
              </div>
              <div className="bg-gray-800 rounded-xl p-4 text-center text-2xl">
                🔥
                <p className="text-xs mt-2">Hot Streak</p>
              </div>
              <div className="bg-gray-800 rounded-xl p-4 text-center text-2xl">
                👑
                <p className="text-xs mt-2">Top Referrer</p>
              </div>
            </div>
          </div>
        )}

        {/* ShopperHub Magazine */}
        {activeTab === "magazine" && (
          <div className="space-y-6">
            <div className="bg-gray-900 rounded-xl p-8 border border-gray-800 text-center">
              <h3 className="text-2xl font-bold mb-4">
                ShopperHub Premium Magazine
              </h3>
              <p className="text-sm text-gray-400 mb-6">
                Exclusive deals, insider tips, seller interviews & earning guides
              </p>
              <p className="text-xs text-gray-500 mb-2">Latest Issue – January 2026</p>
              <div className="text-4xl font-bold text-blue-500 mb-6">
                ₹29/month
              </div>
              <button className="bg-blue-600 text-black py-3 rounded-md font-bold text-xs w-32 lg:text-sm lg:w-64 ">
                Subscribe Now
              </button>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <h4 className="font-semibold mb-3">This Month's Highlights</h4>
              <ul className="text-sm text-gray-400 space-y-2">
                <li>• Top 20 Clearance Deals of the Season</li>
                <li>• How to Maximize Group Buy Savings</li>
                <li>• Verified Seller Spotlight</li>
                <li>• Reward Hacks for Extra Coins</li>
              </ul>
            </div>
          </div>
        )}

        {/* Wallet */}
        {activeTab === "wallet" && (
          <div className="space-y-6">
            <div className="bg-gray-900 rounded-xl p-8 border border-gray-800 text-center">
              <p className="text-sm text-gray-400">Available Balance</p>
              <h2 className="text-5xl font-bold text-blue-500 my-4">
                ₹1,850
              </h2>
              <div className="flex flex-row justify-center gap-4 mt-2">
                <button className="bg-blue-600 text-black py-3 rounded-md font-semibold text-xs w-36 lg:text-sm lg:w-48 ">
                  Use in Purchase
                </button>
                <button className="bg-gray-700 text-blue-400 py-3 rounded-md font-semibold text-xs w-36 lg:text-sm lg:w-48 ">
                  Withdraw to Bank
                </button>
              </div>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <h4 className="font-semibold mb-4">Recent Transactions</h4>
              {dummyTransactions.map((t, i) => (
                <div
                  key={i}
                  className="flex justify-between py-3 border-b border-gray-800 last:border-0 text-sm"
                >
                  <div>
                    <p className="font-medium">{t.date}</p>
                    <p className="text-xs text-gray-400">{t.desc}</p>
                  </div>
                  <span
                    className={
                      t.amount.startsWith("+")
                        ? "text-green-400 font-semibold"
                        : "text-red-400 font-semibold"
                    }
                  >
                    {t.amount}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Trends */}
        {activeTab === "insights" && (
          <div className="space-y-8">
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <h3 className="text-lg font-semibold mb-4">
                Deal Views Trend (Last 7 Days)
              </h3>
              <div className="h-64">
                <canvas ref={lineChartRef} />
              </div>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <h3 className="text-lg font-semibold mb-4">
                Popularity by Offer Type
              </h3>
              <div className="h-64">
                <canvas ref={barChartRef} />
              </div>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <h3 className="text-sm font-semibold mb-3">🔥 Trending Today</h3>
              <ul className="text-sm text-gray-400 space-y-2">
                <li>• Winter Clothing Clearance Sales</li>
                <li>• Kitchen Storage & Organization</li>
                <li>• Electronics Accessories Combos</li>
                <li>• Group Grocery & Essentials</li>
                <li>• Factory Seconds Footwear</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}